/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3J1bGVib29rL2xpYi9jb21wb25lbnRzL2FydGljbGUtcGFnZS1jb21tb24vYXJ0aWNsZS1wYWdlLWNvbW1vbi5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
